import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { startOfDay } from 'date-fns';
import { fromDateStampObject, toDateStampObject } from './time';
export class DiscountPeriodExpirationModel {
    static fromDTO(dto) {
        if (dto.type === 'none') {
            return new DiscountPeriodExpirationModel({
                type: 'none'
            });
        }
        const expiration = dto.type === 'period' ? {
            type: 'period',
            period: dto.period
        } : {
            type: 'date',
            date: {
                date: dto.date.date,
                status: dto.date.status
            }
        };
        return new DiscountPeriodExpirationModel(expiration);
    }
    static fromDBDTO(dto) {
        if (dto.type === 'none') {
            return new DiscountPeriodExpirationModel({
                type: 'none'
            });
        }
        if (dto.type === 'period' && dto.period) {
            return new DiscountPeriodExpirationModel({
                type: 'period',
                period: {
                    type: dto.period.type,
                    amount: dto.period.amount,
                    status: dto.status
                }
            });
        }
        if (dto.type === 'date' && dto.date) {
            return new DiscountPeriodExpirationModel({
                type: 'date',
                date: {
                    date: dto.date,
                    status: dto.status
                }
            });
        }
        return new DiscountPeriodExpirationModel({
            type: 'none'
        });
    }
    toDTO() {
        return this.expiration;
    }
    toDBDTO() {
        if (this.expiration.type === 'none') {
            return {
                type: 'none'
            };
        }
        if (this.expiration.type === 'period') {
            return {
                type: 'period',
                period: {
                    type: this.expiration.period.type,
                    amount: this.expiration.period.amount
                },
                status: this.expiration.period.status
            };
        }
        if (this.expiration.type === 'date') {
            return {
                type: 'date',
                date: this.expiration.date.date,
                status: this.expiration.date.status
            };
        }
        return {
            type: 'none'
        };
    }
    static makeDate(date) {
        return new DiscountPeriodExpirationModel({
            type: 'date',
            date: {
                date: toDateStampObject(startOfDay(date)),
                status: 'active'
            }
        });
    }
    static makePeriod(type, amount, expectedExpirationDate) {
        let status = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 'active';
        return new DiscountPeriodExpirationModel({
            type: 'period',
            period: {
                type,
                amount,
                status,
                expectedExpirationDate: expectedExpirationDate ? toDateStampObject(expectedExpirationDate) : undefined
            }
        });
    }
    static makeNone() {
        return new DiscountPeriodExpirationModel({
            type: 'none'
        });
    }
    isNone() {
        return this.expiration.type === 'none';
    }
    type() {
        return this.expiration.type;
    }
    date() {
        if (this.expiration.type === 'date') {
            return fromDateStampObject(this.expiration.date.date);
        }
        if (this.expiration.type === 'period' && this.expiration.period.expectedExpirationDate) {
            return fromDateStampObject(this.expiration.period.expectedExpirationDate);
        }
        return undefined;
    }
    period() {
        return this.expiration.type === 'period' ? this.expiration.period.type : undefined;
    }
    amount() {
        return this.expiration.type === 'period' ? this.expiration.period.amount : undefined;
    }
    isExpirationDateType() {
        return this.expiration.type === 'date';
    }
    isExpirationPeriodType() {
        return this.expiration.type === 'period';
    }
    isActive() {
        if (this.expiration.type === 'none') return false;
        if (this.expiration.type === 'date') {
            return this.expiration.date.status === 'active';
        }
        if (this.expiration.type === 'period') {
            return this.expiration.period.status === 'active';
        }
        return false;
    }
    isExpired() {
        if (this.expiration.type === 'none') return false;
        if (this.expiration.type === 'date') {
            return this.expiration.date.status === 'expired';
        }
        if (this.expiration.type === 'period') {
            return this.expiration.period.status === 'expired';
        }
        return false;
    }
    hasExpiration() {
        return this.expiration.type === 'period' || this.expiration.type === 'date';
    }
    periodTypeIsDays() {
        return this.expiration.type === 'period' && this.expiration.period.type === 'days';
    }
    periodTypeIsWeeks() {
        return this.expiration.type === 'period' && this.expiration.period.type === 'weeks';
    }
    periodTypeIsMonths() {
        return this.expiration.type === 'period' && this.expiration.period.type === 'months';
    }
    periodTypeIsYears() {
        return this.expiration.type === 'period' && this.expiration.period.type === 'years';
    }
    timeframeTypeIsPeriod() {
        return this.expiration.type === 'period';
    }
    timeframeTypeIsDate() {
        return this.expiration.type === 'date';
    }
    matchPeriod(periodType, visitor) {
        switch(periodType){
            case 'days':
                return visitor.days();
            case 'weeks':
                return visitor.weeks();
            case 'months':
                return visitor.months();
            case 'years':
                return visitor.years();
        }
    }
    constructor(expiration){
        _define_property(this, "expiration", void 0);
        this.expiration = expiration;
    }
}
